const apiBase = (process.env.NEXT_PUBLIC_API_URL || '').replace(/\/$/, '');

export function getDownloadLink(assetId: string) {
   return `${apiBase}/brochures/download/${assetId}`;
}

export async function logBrochureClick(params: {
  model: string;
  pageUrl: string;
  brochureAsset: string;
}) {
  try {
    await fetch('/api/brochures/click', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params),
    });
  } catch (error) {
    console.error('Error logging brochure click:', error);
  }
}

export async function sendBrochureRequest(params: {
  name: string;
  email: string;
  model: string;
  pageUrl: string;
  brochureAsset: string;
  additionalBrochureAsset?: string;
}) {
  try {
    const response = await fetch('/api/brochures/request', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params),
    });

    if (!response.ok) throw new Error('Failed to send brochure request');

    return await response.json();
  } catch (error) {
    console.error('Error sending brochure request:', error);
    throw error;
  }
}

export async function sendWhatsAppBrochureRequest(params: {
  name: string;
  whatsappNumber: string;
  model: string;
  pageUrl: string;
  brochureAsset: string;
  additionalBrochureAsset?: string;
}) {
  const response = await fetch('/api/brochures/whatsapp-request', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params),
  });

  if (!response.ok) {
    throw new Error('Failed to send brochure via WhatsApp');
  }

  return response.json();
}
